module.exports = function() {
  return new Worker(__webpack_public_path__ + "f76447d040ebe8249307.worker.js");
};